<template>
	<div id="app" :data-theme="theme">
		<div
			class="app-cover"
			v-if="background"
			:style="`background-image:url('${background.url}')`"
		>
			<!-- <img :src="background.url" /> -->
		</div>
		<component :is="layout" v-if="isAuth">
			<router-view />
		</component>
		<modalIntro> </modalIntro>
		<modalProfile></modalProfile>
		<modalOnboarding></modalOnboarding>
		<!-- <modalSetup></modalSetup> -->
		<modalRelogin></modalRelogin>
		<modalAbout></modalAbout>
		<vue-progress-bar></vue-progress-bar>
		<message></message>
	</div>
</template>

<script>
import store from '@/store/index.js';
import modalIntro from '@/components/modals/modal-intro.vue';
import modalProfile from '@/components/modals/modal-profile.vue';
import modalOnboarding from '@/components/modals/modal-onboarding.vue';
//import modalSetup from '@/components/modals/modal-setup';
import modalRelogin from '@/components/modals/modal-relogin.vue';
import modalAbout from '@/components/modals/modal-about.vue';
import message from '@/components/ui/message.vue';
import VueProgressBar from 'vue-progressbar';

import backgrounds from '@/lib/backgrounds.js';

import Vue from 'vue';
window.Vue = Vue;
import router from './router';

import { BootstrapVue } from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import VueHead from 'vue-head';
import Vuelidate from 'vuelidate';
import VCalendar from 'v-calendar';
import { loadStripe } from '@stripe/stripe-js';
import VHighlightJS from '@/lib/highlighter.js';

import layoutBlank from '@/components/layouts/layout-blank.vue';
import layoutSecondary from '@/components/layouts/layout-secondary.vue';

Vue.config.productionTip = false;

Vue.config.errorHandler = function (err, vm, info) {
	console.log(err);
};

Vue.use(VHighlightJS);
Vue.use(Vuelidate);
Vue.use(VueHead);
Vue.use(VueClipboard);
Vue.use(BootstrapVue);
Vue.use(VCalendar, {});
Vue.use(VueProgressBar, {
	color: 'rgb(128, 136, 247)',
	failedColor: 'red',
	height: '2px',
});

Vue.component('layout-blank', layoutBlank);
Vue.component('layout-secondary', layoutSecondary);
let stripePublishableKey =
	'pk_test_51HE8UjHQAqGl0SYu7g24DXaXrlQTEJKyAMdIL2xpitAoNZIepPEWPznFqQUfpjqSBxpuDGUfejAhcCQArDSSaYh300yP36YtaH';
if (process.env.NODE_ENV === 'production') {
	stripePublishableKey =
		'pk_live_51HE8UjHQAqGl0SYuG52eoyb2MZjknzQx982EMn6hbaGkbjXJBxTUwhtEYeZobZaFmL1QWwKGHYL00DdtnooEN3gz002neGtsOj';
}

loadStripe(stripePublishableKey).then((stripe) => {
	Vue.prototype.stripe = stripe;
});

export default {
	store,
	router,
	components: {
		modalIntro,
		modalProfile,
		modalOnboarding,
		//modalSetup,
		modalRelogin,
		modalAbout,
		message,
	},
	head: {
		script: [
			{
				type: 'text/javascript',
				src: 'https://js.stripe.com/v3/',
			},
		],
	},
	data: function () {
		return {
			backgrounds: backgrounds,
			options: {
				highlight: true,
			},
		};
	},
	computed: {
		hasBackground: function () {
			return this.$store.getters['settings/hasBackground'];
		},
		background: function () {
			if (this.hasBackground) {
				let data = null;
				this.backgrounds.map((bg) => {
					if (bg.value === this.hasBackground) {
						data = bg;
					}
				});
				return data;
			}

			return null;
		},
		loaderState: function () {
			return this.$store.getters['ui/loaderState'];
		},
		layout: function () {
			return 'layout-' + (this.$route.meta.layout || 'secondary');
		},
		theme: function () {
			return this.$store.state.theme;
		},
		relogin: function () {
			return this.$store.getters['user/relogin'];
		},
		isAuth: function () {
			return this.$store.getters['user/isAuth'];
		},
	},
	watch: {
		loaderState: function () {
			if (this.loaderState) {
				this.$Progress.start();
			} else {
				this.$Progress.finish();
			}
		},
		relogin: function () {
			this.$bvModal.show('modal-relogin');
		},
		isAuth: function () {
			if (!this.isAuth) {
				this.$bvModal.show('modal-intro');
			} else {
				this.$bvModal.hide('modal-intro');
				//this.$bvModal.show('modal-setup');
				setTimeout(() => {
					if (this.$store.getters.afterSignup) {
						this.$bvModal.show('modal-onboarding');
					}
				}, 1000);
			}
		},
		theme: {
			handler: function () {
				document.querySelector('body').classList.add(this.theme);
				document.querySelector('body').setAttribute('data-theme', this.theme);
			},
			immediate: true,
		},
	},
	methods: {},
	mounted: function () {
		this.$store.dispatch('init').then((logggedIn) => {
			if (!logggedIn) {
				this.$bvModal.show('modal-intro');
			}
		});
	},
};
</script>

<style lang="scss">
@import 'assets/styles/main.scss';

body {
	@include scrollBars();
}

#app {
	position: relative;
	background-color: var(--g4);
	height: 100vh;
	min-height: 100vh;

	.app-cover {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-position: center center;
		background-size: cover;

		img {
			position: absolute;
			top: 0;
			left: 0;
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: left center;
		}

		// &:after {
		//   content: "";
		//   position: absolute;
		//   top: 0;
		//   left: 0;
		//   width: 100%;
		//   height: 100%;
		//   background-color: rgba(0, 0, 0, 0.5);
		//   mix-blend-mode: lighten;
		// }
	}

	// .layout {
	//   height: 100%;
	// }
}

.wrapper {
	min-height: 100vh;
}

.main {
	&-wrapper {
		// box-shadow: 0 1px 2.2px rgba(0, 0, 0, 0.02),
		//   0 2.3px 5.3px rgba(0, 0, 0, 0.028), 0 4.4px 10px rgba(0, 0, 0, 0.035),
		//   0 7.8px 17.9px rgba(0, 0, 0, 0.042), 0 14.6px 33.4px rgba(0, 0, 0, 0.05),
		//   0 35px 80px rgba(0, 0, 0, 0.07);
		overflow: hidden;

		::selection {
			color: var(--s1);
			background-color: var(--s2);
		}
	}
}
</style>
